import { useTranslator } from "@eo-locale/react";

import { Alert, Box, Flex } from "@/storybook-components";
import ListCard from "./list-card";
import { scrollIntoView } from "@/lib";
import type { Projects } from "@/types";
import { setCurrentPage } from "@/redux/features/projects/slice";
import Card from "@/theme/components/card";
import Pagination from "@/theme/components/pagination";
import { useAppDispatch, useAppSelector } from "@/redux/store/hooks";

const List = ({ projects }: Projects): JSX.Element => {
  const dispatch = useAppDispatch();
  const { translate } = useTranslator();
  const { queryFilter } = useAppSelector((state) => state.projectFinder);
  const { currentPage } = useAppSelector((state) => state.projects);

  const { enablePagination, locales, perPage } = queryFilter;

  const renderProjects = () => {
    const totalPages = projects.length;

    if (totalPages <= 0) {
      return (
        <Alert status="info">
          {locales["projects.noContent"] ||
            translate("projectFinder.noContent")}
        </Alert>
      );
    }

    if (enablePagination) {
      // get index of first & last project and update the projects array
      const indexOfLastProject = currentPage * perPage;
      const indexOfFirstProject = indexOfLastProject - perPage;

      projects = projects.slice(indexOfFirstProject, indexOfLastProject);
    }

    const paginate = (currentPage: number): void => {
      scrollIntoView();
      dispatch(setCurrentPage(currentPage));
    };

    return (
      <>
        <Flex
          flexWrap="wrap"
          className="ehq-projectsContainer"
          flexDirection={["column", "column", "row", "row"]}
        >
          {projects.map((project) => renderProject(project))}
        </Flex>
        {enablePagination ? (
          <Flex py="15px" justify="center" className="ehq-paginationContainer">
            <Pagination
              paginate={paginate}
              total={totalPages}
              currentPage={currentPage}
              pageSize={perPage}
              key="pagination"
            />
          </Flex>
        ) : null}
      </>
    );
  };

  const renderProject = (project) => {
    return (
      <Box
        mb={[0, 0, 3]}
        fontSize="sm"
        className="ehq-projectCardContainer"
        w={["100%", "100%", "50%", "33.33%"]}
        key={project.id}
      >
        <Card m={2} display="block" height="100%" key={project.id}>
          <ListCard project={project} />
        </Card>
      </Box>
    );
  };
  return renderProjects();
};

export default List;
